import { MuiButton } from '@/components/button/MuiButton';
import { RHFSelect } from '@/components/select/RHFSelect';
import { MuiTextField } from '@/components/textfield/MuiTextField';
import { PREFECTURES } from '@/data/prefectures';
import { SearchHospitalsType } from '@/schemas/SearchParamsSchemas/app/stations/search/hospitals/Schema';
import { MOVING_MINUTES, STATION_ADVANCED_SEARCH_TYPES } from '@/types/types';
import { Box, InputAdornment, MenuItem } from '@mui/material';
import { useFormContext } from 'react-hook-form';

export function SearchConditions() {
  const method = useFormContext<SearchHospitalsType>();
  const searchType = method.watch('searchType');

  return (
    <>
      {searchType === STATION_ADVANCED_SEARCH_TYPES.ZIPCODE && (
        <>
          <Box
            sx={{
              width: 1,
              '@media (max-width: 800px)': {
                gridRow: 1,
                gridColumn: '1 / span 2',
              },
            }}
          >
            <MuiTextField
              name={method.control.register('location.zipcode').name}
              control={method.control}
              placeholder="郵便番号（例:1110000）"
              fullWidth
              size="small"
              sx={{ backgroundColor: '#FAFAFA' }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">〒</InputAdornment>
                ),
              }}
            />
          </Box>
        </>
      )}

      {searchType === STATION_ADVANCED_SEARCH_TYPES.ADDRESS && (
        <>
          <Box
            sx={{
              width: 1,
              '@media (max-width: 800px)': {
                gridRow: 1,
                gridColumn: 1,
              },
            }}
          >
            <RHFSelect
              name={method.control.register('location.pref_name').name}
              control={method.control}
              sx={{ backgroundColor: '#FAFAFA', height: '40px' }}
              placeholder="都道府県"
              variant="outlined"
            >
              {PREFECTURES.map((pref) => {
                return (
                  <MenuItem key={pref.value} value={pref.text}>
                    {pref.text}
                  </MenuItem>
                );
              })}
            </RHFSelect>
          </Box>

          <Box
            sx={{
              width: 1,
              '@media (max-width: 800px)': {
                gridRow: 1,
                gridColumn: 2,
              },
            }}
          >
            <MuiTextField
              name={method.control.register('location.address').name}
              control={method.control}
              placeholder="都道府県以降の住所を入力"
              fullWidth
              size="small"
              sx={{ backgroundColor: '#FAFAFA' }}
            />
          </Box>
        </>
      )}

      {searchType === STATION_ADVANCED_SEARCH_TYPES.PARTNER && (
        <>
          <Box
            sx={{
              width: 1,
              '@media (max-width: 800px)': {
                gridRow: 1,
                gridColumn: 1,
              },
            }}
          >
            <RHFSelect
              name={method.control.register('location.pref_name').name}
              control={method.control}
              sx={{ backgroundColor: '#FAFAFA', height: '40px' }}
              placeholder="都道府県"
              variant="outlined"
            >
              {PREFECTURES.map((pref) => {
                return (
                  <MenuItem key={pref.value} value={pref.text}>
                    {pref.text}
                  </MenuItem>
                );
              })}
            </RHFSelect>
          </Box>

          <Box
            sx={{
              width: 1,
              '@media (max-width: 800px)': {
                gridRow: 1,
                gridColumn: 2,
              },
            }}
          >
            <MuiTextField
              name={method.control.register('partnerName').name}
              control={method.control}
              placeholder="地域連携先"
              fullWidth
              size="small"
              sx={{ backgroundColor: '#FAFAFA' }}
            />
          </Box>
        </>
      )}

      <Box
        sx={{
          width: 1,
          '@media (max-width: 800px)': {
            gridRow: 2,
            gridColumn: 2,
          },
        }}
      >
        <RHFSelect
          name={method.control.register('location.moving_minutes').name}
          control={method.control}
          sx={{ backgroundColor: '#FAFAFA', height: '40px' }}
          variant="outlined"
        >
          {MOVING_MINUTES.map((mm) => {
            return (
              <MenuItem key={mm.value} value={mm.value}>
                {mm.text}
              </MenuItem>
            );
          })}
        </RHFSelect>
      </Box>

      <Box
        sx={{
          '@media (max-width: 800px)': {
            gridRow: 3,
            gridColumn: '1 / span 2',
          },
        }}
      >
        <MuiButton
          sx={{
            width: '64px',
            height: '40px',
            ml: 1,
            mt: 0,
            background: '#33BEB9',
            '@media (max-width: 800px)': {
              width: '100%',
              height: '40px',
              ml: 0,
              mt: 1,
              background: '#33BEB9',
            },
            '&:hover': {
              background: '#33BEB9',
            },
          }}
          type="submit"
          disabled={
            // NOTE: 郵便番号が空の状態で検索ボタンを押されないようにする
            //      可能なら、郵便番号のバリデーションや住所検索でのバリデーションも追加したい
            method.watch('searchType') ===
              STATION_ADVANCED_SEARCH_TYPES.ZIPCODE &&
            method.watch('location.zipcode') === ''
          }
        >
          検索
        </MuiButton>
      </Box>
    </>
  );
}
